// Emissions per Distance (KM) traveled, for electric AND ice vehicles
// Sheet:!CO2 Emissions

export {
  getGasolineEmissionsPerKm,
  getDieselEmissionsPerKm,
  getCNGEmissionsPerKm,
} from './ice';

export {
  getElectricEmissionsPerKm
} from './electric'

export const debugCarbonEmissions = () => {
  // console.log('EMISSIONS', AVERAGE_GRID_EMISSION_FACTOR);
  // console.log('GOAL FUEL MIX', GOAL_FUEL_MIX);
  // console.log('GROWTH_RATE Commercial', GROWTH_RATE.publicTransit);
}



// WEBPACK FOOTER //
// ./src/store/selectors/carbonPollution/carbonEmissionRate/index.ts